/**
 * LeagueList - Componente Presentacional
 * 
 * Componente que renderiza un grid de cápsulas seleccionables para ligas.
 * Cada cápsula contiene un checkbox y el nombre de la liga.
 * Responde a clicks en la cápsula o en el checkbox para alternar selección.
 * 
 * @component
 * @param {Object} props - Props del componente
 * @param {Array} props.leagues - Array de ligas a renderizar
 *   Estructura: { id: string, name: string, know_name?: string, status: boolean, ... }
 * @param {Function} props.onToggleLeague - Callback ejecutado al hacer click en una cápsula
 *   Recibe el ID de la liga como parámetro: onToggleLeague(leagueId)
 * @returns {JSX.Element} Grid de cápsulas seleccionables
 * 
 * Características:
 * - Grid responsivo: 2 columnas en mobile, 4 en desktop
 * - Las cápsulas seleccionadas tienen clase 'selected' (fondo azul)
 * - Usa know_name si está disponible, sino usa name
 * - El checkbox detiene la propagación para alternar el estado una sola vez
 */

export default function LeagueList({ leagues, onToggleLeague }) {
  return (
    <div className="league-check-list">
      {leagues.map(league => (
        <div
          key={league.id}
          className={`league-capsule ${league.status ? 'selected' : ''}`}
          onClick={() => onToggleLeague(league.id)}
        >
          <input
            type="checkbox"
            checked={league.status}
            onClick={event => event.stopPropagation()}
            onChange={() => onToggleLeague(league.id)}
            className="league-checkbox"
          />
          <span className="league-name">
            {league.know_name ? league.know_name : league.name}
          </span>
        </div>
      ))}
    </div>
  );
}